import { Layout, Typography, Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SuccessIcon from "../../../assets/icons/green-icon.svg";
import logo from "../../../assets/icons/twizz-logo-white.svg";
import AuthButtonComponent from "../../../components/AuthButtonCompnent";
import "./index.less";

const { Content } = Layout;
const { Text } = Typography;

const EmailVerifiedPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout className="email-verified-page gradient-background">
      <Content className="email-verified-content">
        <Row justify="center" className="logo-row">
          <img src={logo} className="logo" alt="logo" onClick={() => navigate("/")} />
        </Row>

        <Row justify="center" className="title-row">
          <Text className="title">{t("email-verified-title")}</Text>
        </Row>

        <Row justify="center" className="icon-row">
          <img src={SuccessIcon} className="success-icon" alt="Success" />
        </Row>

        <Row justify="center" className="text-row">
          <Text className="description">{t("email-verified-text")}</Text>
        </Row>

        <Row justify="center" className="button-row">
          <AuthButtonComponent label={t("auth-signIn-button")} onClick={() => navigate("/")} />
        </Row>
      </Content>
    </Layout>
  );
};

export default EmailVerifiedPage;
